package ca.northroot.app.data

import dev.gitlive.firebase.firestore.DocumentSnapshot

actual fun DocumentSnapshot.getTime(field: String): Long? {
    return try {
        // 1. Try to get as structured object (FirebaseTimestamp)
        // This is the safest way to avoid the 'Any' serializer error
        try {
            val ts = this.get<FirebaseTimestamp?>(field)
            if (ts != null) return ts.toEpochMilliseconds()
        } catch (e: Exception) {
            // Not a FirebaseTimestamp or missing serializer
        }

        // 2. Try to get as numeric (Double)
        try {
            val num = this.get<Double?>(field)
            if (num != null) return num.toLong()
        } catch (e: Exception) {
            // Not a number
        }

        null
    } catch (e: Exception) {
        null
    }
}
